import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter, Music2, LinkIcon, Mail, Phone, Lock } from "lucide-react";
import Logo from "./Logo";
import Sparkle from "./Sparkle";

const social = [
  { href: "https://instagram.com/Shaycooksllc", icon: Instagram, label: "Instagram" },
  { href: "https://tiktok.com/@Shaycooksllc", icon: Music2, label: "TikTok" },
  { href: "https://facebook.com/Shaycooksllc", icon: Facebook, label: "Facebook" },
  { href: "https://youtube.com/@Shaycooksllc", icon: Youtube, label: "YouTube" },
  { href: "https://x.com/Shaycooksllc", icon: Twitter, label: "X" },
  { href: "https://linktr.ee/Shaycooksllc", icon: LinkIcon, label: "Linktree" },
];

export const Footer = () => {
  return (
    <footer className="bg-shay-navy text-shay-cream pt-20 pb-28 lg:pb-12 paper-noise relative overflow-hidden" data-testid="site-footer">
      <div className="floating-cookie -top-10 -left-10 w-48 h-48" />
      <div className="floating-cookie bottom-20 right-10 w-32 h-32" />

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Logo variant="plain" size="lg" />
            <p className="font-script text-shay-gold text-3xl mt-5 flex items-center gap-3">
              <Sparkle size={14} color="#C89A36" />
              Did You Eat?
              <Sparkle size={14} color="#C89A36" />
            </p>
            <p className="mt-6 text-shay-cream/70 leading-relaxed max-w-md">
              Small batch gourmet cookies and brownies. Baked with love in a home kitchen,
              packaged with care, and delivered fresh to your door.
            </p>
            <div className="flex flex-wrap gap-3 mt-8">
              {social.map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  aria-label={label}
                  className="h-11 w-11 grid place-items-center rounded-full border border-shay-gold/40 text-shay-cream hover:text-shay-navy hover:bg-shay-gold transition-colors"
                >
                  <Icon size={17} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow eyebrow-gold">Explore</p>
            <ul className="mt-5 space-y-3 font-display text-xl">
              <li><Link to="/menu" data-testid="footer-link-menu" className="hover:text-shay-gold transition-colors">Menu</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-shay-gold transition-colors">About Shay</Link></li>
              <li><Link to="/reviews" data-testid="footer-link-reviews" className="hover:text-shay-gold transition-colors">Reviews</Link></li>
              <li><Link to="/track" data-testid="footer-link-track" className="hover:text-shay-gold transition-colors">Track Order</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-shay-gold transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow eyebrow-gold">Get In Touch</p>
            <ul className="mt-5 space-y-4">
              <li className="flex items-center gap-3 text-shay-cream/85">
                <Mail size={16} className="text-shay-gold" />
                <a href="mailto:Business@ShayCooks.com" className="hover:text-shay-gold" data-testid="footer-email">
                  Business@ShayCooks.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-shay-cream/85">
                <Phone size={16} className="text-shay-gold" />
                <a href="tel:+14077340119" className="hover:text-shay-gold" data-testid="footer-phone">
                  (407) 734-0119
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-shay-gold/20">
          <p className="text-[11px] leading-relaxed uppercase tracking-[0.2em] text-shay-cream/55 max-w-4xl" data-testid="footer-allergen-disclaimer">
            <span className="text-shay-gold">Allergen Disclaimer —</span> Our baked goods are made in a home kitchen
            where wheat, dairy, eggs, soy, peanuts, and tree nuts are used. If you have a food allergy,
            please use caution, as we cannot guarantee that any item is completely free of allergens.
          </p>
          <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] tracking-widest uppercase text-shay-cream/55">
            <span>© {new Date().getFullYear()} Shay Cooks LLC. All rights reserved.</span>
            <div className="flex items-center gap-5">
              <span>Baked fresh in Orlando, FL.</span>
              <span className="text-shay-cream/30">·</span>
              <Link
                to="/admin/login"
                data-testid="footer-admin-link"
                className="text-shay-cream/55 hover:text-shay-gold transition-colors inline-flex items-center gap-1.5"
              >
                <Lock size={11} />
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
